import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path><path d="M12.79 9h13.42C27.195 9 28 8.1 28 7s-.805-2-1.79-2H12.79C11.805 5 11 5.9 11 7s.805 2 1.79 2z"></path><path d="M12.79 18h13.42c.985 0 1.79-.9 1.79-2s-.805-2-1.79-2H12.79c-.985 0-1.79.9-1.79 2s.805 2 1.79 2z"></path><path d="M26.21 27H12.79c-.985 0-1.79-.9-1.79-2s.805-2 1.79-2h13.42c.985 0 1.79.9 1.79 2s-.805 2-1.79 2z"></path><path d="M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"></path><path d="M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path></g>';
export var ListBulletedSVG = function ListBulletedSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ListBulletedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ListBulletedSVG);